/**
 * WVB-02 — Shared financial utilities for Wave B2 frontend
 * NOTE: Display formatting only — all financial calculations done on backend with Python Decimal.
 */

export const CURRENCY_PRECISION = { INR: 2, USD: 2, EUR: 2, GBP: 2, JPY: 0, KWD: 3, AED: 2, SGD: 2 };
export const CURRENCY_SYMBOLS   = { INR: "₹", USD: "$", EUR: "€", GBP: "£", JPY: "¥", AED: "AED ", SGD: "S$" };

export const BUDGET_CATEGORIES = [
  "VENUE", "CATERING", "AV_TECHNOLOGY", "DECOR", "STAFFING",
  "LOGISTICS", "ENTERTAINMENT", "PHOTOGRAPHY", "ACCOMMODATION",
  "PRINTING", "CONTINGENCY", "OVERHEADS", "OTHER",
];

export const UOM_OPTIONS = ["UNIT", "DAY", "HOUR", "ITEM", "SQM", "SQFT", "KG", "LITER", "PAX", "EVENT"];

/** Convert a display-units string (e.g. "2500.00") to integer minor units (paise) */
export function toMinorUnits(displayStr, currency = "INR") {
  const prec = CURRENCY_PRECISION[currency] ?? 2;
  const val = parseFloat(displayStr || "0");
  if (isNaN(val)) return 0;
  return Math.round(val * Math.pow(10, prec));
}

/** Convert integer minor units to a display-units string (e.g. 250000 → "2500.00") */
export function fromMinorUnits(minor, currency = "INR") {
  const prec = CURRENCY_PRECISION[currency] ?? 2;
  return (minor / Math.pow(10, prec)).toFixed(prec);
}

/** Availability badge config */
export const AVAIL_CONFIG = {
  AVAILABLE:          { label: "Available",           cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  NOT_YET_AVAILABLE:  { label: "Not yet available",   cls: "bg-slate-50 text-slate-500 border-slate-200" },
  NO_COMMERCIAL_REF:  { label: "No commercial ref",   cls: "bg-amber-50 text-amber-600 border-amber-200" },
};

/** Budget status badge config */
export const BUDGET_STATUS_CONFIG = {
  DRAFT:     { cls: "bg-slate-100 text-slate-600",   label: "Draft" },
  SUBMITTED: { cls: "bg-blue-50 text-blue-700",      label: "Submitted" },
  APPROVED:  { cls: "bg-emerald-50 text-emerald-700",label: "Approved" },
  SUPERSEDED:{ cls: "bg-slate-100 text-slate-400",   label: "Superseded" },
};
